import type { FileName } from "@pdfking/structs"

import { JoinPath } from "./JoinPath"
import { SplitPath } from "./SplitPath"

/** A key in the one spelling its storage uses.
 *
 * Empty segments carry no meaning — see {@link SplitPath} — so "/a/b", "a//b"
 * and "a/b" name one entry, and a storage that took them at face value would
 * hold three. Every backend normalizes what it is handed, so a caller may
 * write a path however it says it and read the same entry back. */
export const EntryKey = (key: FileName): FileName => JoinPath(...SplitPath(key)) as FileName
